module.exports = __webpack_public_path__ + "static/media/bnr3.629db18f.jpg";